// extracted by mini-css-extract-plugin
export default {"container":"DK3flH"};